export const onlineSchool = [{
  nav: '招生引流',
  title: '线上/线下招生引流',
  sTitle: '快速搭建线上招生获客渠道',
  desc: '通过打通多生态聚合流量、丰富的社交营销裂变玩法以及庞大的内容分销网络，帮助教育机构解决线上招生引流的难题。目前已经打通微信、百度等多个流量生态，辅以数十种社交营销玩法，教育机构能够快速构建自己的私域流量池。',
  tip: '*知链教育培训，一站式解决招生引流、教务管理、学员管理、网络授课、线下课堂、助学互动、经营分析、口碑传播需求，不需要重复购买。',
  img: require('@/assets/images/scenePic9.png'),
  backgroundColor: 'linear-gradient(rgb(249, 253, 255), rgb(243, 246, 252))'
}, {
  nav: '品牌网校',
  title: '品牌网校',
  sTitle: '独立网校构建教育机构品牌',
  desc: '帮助教育机构和讲师快速搭建自己的独立网校平台，支持PC网页、微信H5、小程序等多种终端形式，让教育机构品牌覆盖各个流量生态，汇聚沉淀自己的学员用户。',
  tip: '*知链教育培训，一站式解决招生引流、教务管理、学员管理、网络授课、线下课堂、助学互动、经营分析、口碑传播需求，不需要重复购买。',
  img: require('@/assets/images/scenePic9.png'),
  backgroundColor: 'linear-gradient(rgb(255, 252, 254), rgb(255, 249, 251))'
}, {
  nav: '内容形式',
  title: '线上/线下招生引流',
  sTitle: '快速搭建线上招生获客渠道',
  desc: '通过打通多生态聚合流量、丰富的社交营销裂变玩法以及庞大的内容分销网络，帮助教育机构解决线上招生引流的难题。目前已经打通微信、百度等多个流量生态，辅以数十种社交营销玩法，教育机构能够快速构建自己的私域流量池。',
  tip: '*知链教育培训，一站式解决招生引流、教务管理、学员管理、网络授课、线下课堂、助学互动、经营分析、口碑传播需求，不需要重复购买。',
  img: require('@/assets/images/scenePic9.png'),
  backgroundColor: 'linear-gradient(rgb(249, 254, 255), rgb(243, 253, 255))'
}, {
  nav: '互动课堂',
  title: '线上/线下招生引流',
  sTitle: '快速搭建线上招生获客渠道',
  desc: '通过打通多生态聚合流量、丰富的社交营销裂变玩法以及庞大的内容分销网络，帮助教育机构解决线上招生引流的难题。目前已经打通微信、百度等多个流量生态，辅以数十种社交营销玩法，教育机构能够快速构建自己的私域流量池。',
  tip: '*知链教育培训，一站式解决招生引流、教务管理、学员管理、网络授课、线下课堂、助学互动、经营分析、口碑传播需求，不需要重复购买。',
  img: require('@/assets/images/scenePic9.png'),
  backgroundColor: 'linear-gradient(rgb(254, 255, 251), rgb(254, 253, 250))'
}, {
  nav: 'AI教学',
  title: '线上/线下招生引流',
  sTitle: '快速搭建线上招生获客渠道',
  desc: '通过打通多生态聚合流量、丰富的社交营销裂变玩法以及庞大的内容分销网络，帮助教育机构解决线上招生引流的难题。目前已经打通微信、百度等多个流量生态，辅以数十种社交营销玩法，教育机构能够快速构建自己的私域流量池。',
  tip: '*知链教育培训，一站式解决招生引流、教务管理、学员管理、网络授课、线下课堂、助学互动、经营分析、口碑传播需求，不需要重复购买。',
  img: require('@/assets/images/scenePic9.png'),
  backgroundColor: 'linear-gradient(rgb(248, 252, 255), rgb(244, 250, 255))'
}, {
  nav: '线下课',
  title: '线上/线下招生引流',
  sTitle: '快速搭建线上招生获客渠道',
  desc: '通过打通多生态聚合流量、丰富的社交营销裂变玩法以及庞大的内容分销网络，帮助教育机构解决线上招生引流的难题。目前已经打通微信、百度等多个流量生态，辅以数十种社交营销玩法，教育机构能够快速构建自己的私域流量池。',
  tip: '*知链教育培训，一站式解决招生引流、教务管理、学员管理、网络授课、线下课堂、助学互动、经营分析、口碑传播需求，不需要重复购买。',
  img: require('@/assets/images/scenePic9.png'),
  backgroundColor: 'linear-gradient(rgb(252, 255, 255), rgb(244, 254, 255))'
}, {
  nav: '学员CRM',
  title: '线上/线下招生引流',
  sTitle: '快速搭建线上招生获客渠道',
  desc: '通过打通多生态聚合流量、丰富的社交营销裂变玩法以及庞大的内容分销网络，帮助教育机构解决线上招生引流的难题。目前已经打通微信、百度等多个流量生态，辅以数十种社交营销玩法，教育机构能够快速构建自己的私域流量池。',
  tip: '*知链教育培训，一站式解决招生引流、教务管理、学员管理、网络授课、线下课堂、助学互动、经营分析、口碑传播需求，不需要重复购买。',
  img: require('@/assets/images/scenePic9.png'),
  backgroundColor: 'linear-gradient(rgb(249, 253, 255), rgb(243, 246, 252))'
}, {
  nav: '校区管理',
  title: '线上/线下招生引流',
  sTitle: '快速搭建线上招生获客渠道',
  desc: '通过打通多生态聚合流量、丰富的社交营销裂变玩法以及庞大的内容分销网络，帮助教育机构解决线上招生引流的难题。目前已经打通微信、百度等多个流量生态，辅以数十种社交营销玩法，教育机构能够快速构建自己的私域流量池。',
  tip: '*知链教育培训，一站式解决招生引流、教务管理、学员管理、网络授课、线下课堂、助学互动、经营分析、口碑传播需求，不需要重复购买。',
  img: require('@/assets/images/scenePic9.png'),
  backgroundColor: 'linear-gradient(rgb(255, 252, 254), rgb(255, 249, 251))'
}, {
  nav: '教务管理',
  title: '线上/线下招生引流',
  sTitle: '快速搭建线上招生获客渠道',
  desc: '通过打通多生态聚合流量、丰富的社交营销裂变玩法以及庞大的内容分销网络，帮助教育机构解决线上招生引流的难题。目前已经打通微信、百度等多个流量生态，辅以数十种社交营销玩法，教育机构能够快速构建自己的私域流量池。',
  tip: '*知链教育培训，一站式解决招生引流、教务管理、学员管理、网络授课、线下课堂、助学互动、经营分析、口碑传播需求，不需要重复购买。',
  img: require('@/assets/images/scenePic9.png'),
  backgroundColor: 'linear-gradient(rgb(249, 254, 255), rgb(243, 253, 255))'
}, {
  nav: '学员管理',
  title: '线上/线下招生引流',
  sTitle: '快速搭建线上招生获客渠道',
  desc: '通过打通多生态聚合流量、丰富的社交营销裂变玩法以及庞大的内容分销网络，帮助教育机构解决线上招生引流的难题。目前已经打通微信、百度等多个流量生态，辅以数十种社交营销玩法，教育机构能够快速构建自己的私域流量池。',
  tip: '*知链教育培训，一站式解决招生引流、教务管理、学员管理、网络授课、线下课堂、助学互动、经营分析、口碑传播需求，不需要重复购买。',
  img: require('@/assets/images/scenePic9.png'),
  backgroundColor: 'linear-gradient(rgb(254, 255, 251), rgb(254, 253, 250))'
}, {
  nav: '讲师管理',
  title: '线上/线下招生引流',
  sTitle: '快速搭建线上招生获客渠道',
  desc: '通过打通多生态聚合流量、丰富的社交营销裂变玩法以及庞大的内容分销网络，帮助教育机构解决线上招生引流的难题。目前已经打通微信、百度等多个流量生态，辅以数十种社交营销玩法，教育机构能够快速构建自己的私域流量池。',
  tip: '*知链教育培训，一站式解决招生引流、教务管理、学员管理、网络授课、线下课堂、助学互动、经营分析、口碑传播需求，不需要重复购买。',
  img: require('@/assets/images/scenePic9.png'),
  backgroundColor: 'linear-gradient(rgb(248, 252, 255), rgb(244, 250, 255))'
}, {
  nav: '经营分析',
  title: '线上/线下招生引流',
  sTitle: '快速搭建线上招生获客渠道',
  desc: '通过打通多生态聚合流量、丰富的社交营销裂变玩法以及庞大的内容分销网络，帮助教育机构解决线上招生引流的难题。目前已经打通微信、百度等多个流量生态，辅以数十种社交营销玩法，教育机构能够快速构建自己的私域流量池。',
  tip: '*知链教育培训，一站式解决招生引流、教务管理、学员管理、网络授课、线下课堂、助学互动、经营分析、口碑传播需求，不需要重复购买。',
  img: require('@/assets/images/scenePic9.png'),
  backgroundColor: 'linear-gradient(rgb(252, 255, 255), rgb(244, 254, 255))'
}];

export const tradeArr = [{
  title: '早教幼教',
  iconType: 'iconicon_4'
}, {
  title: 'STEM',
  iconType: 'iconicon_9'
}, {
  title: '兴趣教育',
  iconType: 'iconicon_5'
}, {
  title: 'K12课外辅导',
  iconType: 'iconicon_3'
}, {
  title: '大学生教育',
  iconType: 'iconicon_6'
}, {
  title: '出国留学',
  iconType: 'iconicon_2'
}, {
  title: '营地教育',
  iconType: 'iconicon_10'
}, {
  title: '语言培训',
  iconType: 'iconicon_'
}, {
  title: '公务职称',
  iconType: 'iconicon_1'
}, {
  title: '职业教育',
  iconType: 'iconicon_7'
}, {
  title: '企业培训',
  iconType: 'iconicon_8'
}];
